import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import { TextField } from '@material-ui/core';
import Button from 'components/CustomButtons/Button';
import SnackbarContent from 'components/Snackbar/SnackbarContent';
import { FaSpinner } from 'react-icons/fa';
import { dominioDemandaCirurgica } from '../../config/database';

import 'assets/css/alterar-senha.css';

class AlterarSenha extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messageSnack: '',
      colorSnack: '',
      inputSenhaAntigaError: false,
      inputNovaSenhaError: false,
      inputNovaSenhaConfirmaError: false,
      loading: false,
      redirecionaAdmin: false,
    };
  }

  showSnack = (msg, color) => {
    this.setState({
      messageSnack: msg,
      colorSnack: color,
    });
    const snack = document.getElementById('mensagemAlert');
    snack.style.display = 'block';
    snack.focus();
    setTimeout(() => {
      snack.style.display = 'none';
    }, 8000);
  };

  handleSubmit = e => {
    e.preventDefault();

    this.setState({ loading: true });

    const senhaAntiga = document.getElementById('senhaAntiga').value.toString();
    const senhaNova = document.getElementById('novaSenha').value.toString();
    const senhaNovaConfirma = document.getElementById('novaSenhaConfirma').value.toString();

    if (senhaNova === senhaAntiga) {
      this.showSnack('A nova senha não pode ser igual a antiga.', 'warning');
      this.setState({ inputNovaSenhaError: true, loading: false });
      document.getElementById('novaSenha').value = null;
      document.getElementById('novaSenhaConfirma').value = null;
      document.getElementById('novaSenha').focus();

      return;
    }

    if (senhaNova !== senhaNovaConfirma) {
      this.showSnack('A nova senha não confere com a confirmação.', 'warning');
      this.setState({ inputNovaSenhaError: true, loading: false });
      document.getElementById('novaSenha').value = null;
      document.getElementById('novaSenhaConfirma').value = null;
      document.getElementById('novaSenha').focus();

      return;
    }

    const profissional = JSON.parse(localStorage.getItem('profissional'));

    dominioDemandaCirurgica
      .get(`api/alterarSenha/${profissional.userid}/${senhaNova}/${senhaAntiga}`)
      .then(
        res => {
          if (res.status === 200) this.showSnack(res.data.mensagem, 'success');
          this.setState({
            loading: false,
            redirecionaAdmin: true,
          });
        },
        err => {
          if (err.response.status === 401) this.showSnack(err.response.data.mensagem, 'warning');
          else this.showSnack(err.response.data.mensagem, 'danger');
          this.setState({ inputSenhaAntigaError: true, loading: false });
          document.getElementById('senhaAntiga').value = null;
          document.getElementById('senhaAntiga').focus();
        }
      );
  };

  render() {
    if (this.state.redirecionaAdmin) {
      return <Redirect from="/" to="/admin" />;
    }

    return (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={9}>
          <div style={{ display: 'none' }} id="mensagemAlert">
            <SnackbarContent
              id="shackMessage"
              message={this.state.messageSnack}
              close
              color={this.state.colorSnack}
            />
          </div>
          <Card>
            <CardHeader color="rose">
              <strong> Alterar Senha </strong>
            </CardHeader>
            <CardBody>
              <form onSubmit={this.handleSubmit}>
                <TextField
                  name="senhaAntiga"
                  label="Senha antiga"
                  id="senhaAntiga"
                  type="password"
                  required
                  fullWidth
                  error={this.state.inputSenhaAntigaError}
                />
                <br />
                <br />

                <TextField
                  name="novaSenha"
                  label="Nova senha"
                  id="novaSenha"
                  type="password"
                  required
                  fullWidth
                  error={this.state.inputNovaSenhaError}
                />
                <br />
                <br />

                <TextField
                  name="novaSenhaConfirma"
                  label="Confirmar nova senha"
                  id="novaSenhaConfirma"
                  type="password"
                  required
                  fullWidth
                  error={this.state.inputNovaSenhaConfirmaError}
                />
                <br />
                <br />

                <Button
                  type="submit"
                  color="rose"
                  className={this.state.loading && 'loading-alterar-senha'}
                >
                  {this.state.loading ? <FaSpinner /> : <> Alterar </>}
                </Button>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default AlterarSenha;
